import React from 'react';

function TemplateSelector({ templates, selectedTemplateShortName, onSelect, disabled }) {
  return (
    <div className="workkard-creation-template-bar" data-test="workkard-form-template-bar">
      <span className="workkard-creation-template-bar-label wth-1">You have selected</span>
      <div className="formGroup mrNone wth-2">
        <select
          data-test="workkard-form-template-select"
          value={selectedTemplateShortName ?? ''}
          onChange={(event) => onSelect(event.target.value || null)}
          disabled={disabled}
          className="workkard-creation-template-select"
        >
          <option value="">Default</option>
          {templates.map((template) => (
            <option key={template.template_short_name} value={template.template_short_name}>
              {template.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default TemplateSelector;
